import React from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { useTranslation } from 'react-i18next';

const RefundCancellationPolicy = () => {
  const { t } = useTranslation();

  return (
    <LayoutContainer>
      <AdminHeader title={t('header.refundCancellationPolicy')} />
      <div className="page-content-wrapper scrollable">
        <Card className="m-4">
          <div className="p-4 refund-cancellation-content">
            <h3 className="mb-4">{t('header.refundCancellationPolicy')}</h3>

            <p>
              You agree and acknowledge that you may cancel/reschedule your booking for an EV at any point of time subject to a Cancellation/Reschedule Fee as explained below:
            </p>
            <p>
              You shall be notified of the applicable Cancellation/Convenience Fee in advance whenever you attempt to cancel/reschedule a booking service request. The notification shall be on the Application and/or the Site. Cancellation rate will be modified time-to-time.
            </p>

            <h5 className="mt-4 mb-3">Cancellation/Convenience Fee will be charged:</h5>
            <ul>
              <li className="mb-2">If you cancel your booking at any time after booking.</li>
              <li className="mb-2">If the EV Driver is delayed for EV charging session by more than fifteen (15) minutes from booking time slot, it will be automatically cancelled and you will be charged Cancellation Fee.</li>
              <li className="mb-2">No Fee for rescheduling the booking.</li>
            </ul>

            <p>
              On Rescheduling booked time slot, Charging Rate Change may apply as per the new rate if defined as per the schedule.
            </p>
            <p>
              If booking cancellation is done by Charge+Zone Admin or Charge Spot/Station Owner in case Charge Spot/Charging Station is under maintenance or Out of Service, No Cancellation Fee will be charged and full paid amount shall be refunded.
            </p>

            <h5 className="mt-4 mb-3">HOW DO I CANCEL BOOKING?</h5>
            <p>If you wish to cancel your online booking:</p>
            <p className="bg-dark p-3 border-left border-primary">
              Login to Charge+Zone app &rarr; Main Menu &rarr; My Bookings &rarr; Click “X” to Cancel the selected booking and proceed. You will be notified by SMS to get the booking cancellation confirmation.
            </p>

            <h5 className="mt-4 mb-3">HOW DO I RESCHEDULE BOOKING?</h5>
            <p>If you wish to reschedule the booking:</p>
            <p className="bg-dark p-3 border-left border-primary">
              Login to Charge+Zone app &rarr; Main Menu &rarr; My Bookings &rarr; Reschedule the selected booking by opting an available booking time slot. You will be notified by SMS about your rescheduled booking detail.
            </p>

            <h5 className="mt-4 mb-3">HOW LONG WILL IT TAKE TO PROCESS MY CANCELLATION REQUEST?</h5>
            <p>
              Once you request the cancellation of your booked time slot(s), it will take approximately 24/48 hours to process the refund. You will be notified of the same by email/SMS.
            </p>

            <h5 className="mt-4 mb-3">WHAT ARE THE MODES OF REFUND AVAILABLE AFTER CANCELLATION?</h5>
            <p>
              If you have cancelled your booking and the cancellation request has been successfully processed, for any payments made for that booking using our payment gateway, amount will be refunded and credited to Charge+Zone wallet. For the refund, the processing time will be 24 hours.
            </p>
          </div>
        </Card>
      </div>
    </LayoutContainer>
  );
};

export default RefundCancellationPolicy;
